import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkModule } from '../../chords/link/link.module';
import { IconModule } from '../icon/icon.module';
import { ActionButtonComponent } from './action-button.component';

@NgModule({
  declarations: [ActionButtonComponent],
  imports: [CommonModule, IconModule, LinkModule],
  exports: [ActionButtonComponent],
})
export class ActionButtonModule {}
